import { Ceil } from "@pdfking/math"

/** The weeks of an agenda for `year`, from the Monday of the week of its 1st
 * of January to the one of its 31st of December: the days from the 1st that
 * Monday is (none or before it), and how many weeks there are. */
export const AgendaWeeks = (year: number): { first: number; weeks: number } => {
  // Monday is the 1st, or the days back to it, none a positive zero
  const back = (new Date(Date.UTC(year, 0, 1)).getUTCDay() + 6) % 7
  const first = back ? -back : 0
  const days = (Date.UTC(year + 1, 0, 1) - Date.UTC(year, 0, 1)) / 86400000
  return { first, weeks: Ceil((days - first) / 7) }
}
